import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const NOIDA = [28.5355, 77.391];
const COLORS = { TRAFFIC_JAM: "#b91c1c", SLOW: "#f97316" };

// same id the table uses, so a click on the map selects the row and the other way round
export const patchRowId = (p) => p._id || `${p.patch_key}|${p.bucket}`;

const OoraJamPatchMap = ({ patches = [], selectedId, onSelect }) => {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);
  const linesRef = useRef(new Map());

  // create the map once
  useEffect(() => {
    const map = L.map(elRef.current).setView(NOIDA, 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
    layerRef.current = L.layerGroup().addTo(map);
    return () => map.remove();
  }, []);

  // draw patches whenever the list changes, then zoom to them
  useEffect(() => {
    const layer = layerRef.current;
    layer.clearLayers();
    linesRef.current = new Map();
    const bounds = [];

    patches.forEach((p) => {
      const pts = (p.path && p.path.length ? p.path : [p.start, p.end])
        .filter(Boolean)
        .map((pt) => [pt.lat, pt.lng]);
      if (pts.length < 2) return;

      const line = L.polyline(pts, {
        color: COLORS[p.speed] || COLORS.SLOW,
        weight: 6,
        opacity: 0.9,
      });
      line.bindTooltip(`${p.road_name || "Unnamed road"} · ${p.speed === "TRAFFIC_JAM" ? "JAM" : "SLOW"}`, { sticky: true });
      line.on("click", () => onSelect && onSelect(patchRowId(p)));
      line.addTo(layer);
      linesRef.current.set(patchRowId(p), line);
      bounds.push(...pts);
    });

    if (bounds.length) mapRef.current.fitBounds(bounds, { padding: [30, 30], maxZoom: 15 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patches]);

  // highlight the selected patch
  useEffect(() => {
    linesRef.current.forEach((line, id) => {
      const on = id === selectedId;
      line.setStyle({ weight: on ? 11 : 6, opacity: on ? 1 : 0.85 });
      if (on) {
        line.bringToFront();
        mapRef.current.fitBounds(line.getBounds(), { padding: [80, 80], maxZoom: 16 });
      }
    });
  }, [selectedId]);

  return <div ref={elRef} className="otd-map" />;
};

export default OoraJamPatchMap;